import React from 'react';
import { MysticalButton } from './ui/MysticalButton';
import { BookOpen, Headphones, Brain, Star, Sparkles } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="relative py-12 md:py-24 bg-[#060d16] overflow-hidden" data-id="element-136">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#c9a84c]/5 blur-[100px] rounded-full pointer-events-none" data-id="element-137" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-138">
        <div className="text-center mb-8 md:mb-16" data-id="element-139">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-[#c8c0b0]" data-id="element-140">
            How To Play The Game
          </h2>
          <p className="text-[#c8c0b0]/60 max-w-2xl mx-auto" data-id="element-141">
            This is the "Operator's Manual" for the reality you were never
            supposed to understand.
          </p>
        </div>

        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-142">
          {/* Tier 1 — eBook + Audiobook */}
          <div className="bg-[#050a0f] border border-[#c8c0b0]/20 rounded-xl p-1 relative overflow-hidden" data-id="element-143">
            <div className="bg-[#0a1520] rounded-lg p-5 md:p-8 h-full flex flex-col" data-id="element-144">
              <div className="mb-4 md:mb-6" data-id="element-145">
                <div className="text-[#c8c0b0]/50 font-mono text-xs tracking-widest mb-2" data-id="element-146">
                  ESSENTIAL PACK
                </div>
                <h3 className="text-2xl font-bold text-[#c8c0b0]" data-id="element-147">
                  eBook + Audiobook
                </h3>
              </div>

              <div className="space-y-3 md:space-y-4 flex-1 mb-5 md:mb-8" data-id="element-148">
                <div className="flex items-start gap-3" data-id="element-149">
                  <div className="w-9 h-9 rounded bg-[#c9a84c]/10 flex items-center justify-center flex-shrink-0 text-[#c9a84c]" data-id="element-150">
                    <BookOpen className="w-4 h-4" data-id="element-151" />
                  </div>
                  <div data-id="element-152">
                    <h4 className="font-bold text-[#c8c0b0] text-sm" data-id="element-153">
                      eBook — PDF Format
                    </h4>
                    <p className="text-[#c8c0b0]/50 text-xs" data-id="element-154">
                      "How to Play the Game" — Read on any device, instantly
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-155">
                  <div className="w-9 h-9 rounded bg-[#c9a84c]/10 flex items-center justify-center flex-shrink-0 text-[#c9a84c]" data-id="element-156">
                    <Headphones className="w-4 h-4" data-id="element-157" />
                  </div>
                  <div data-id="element-158">
                    <h4 className="font-bold text-[#c8c0b0] text-sm" data-id="element-159">
                      Audiobook
                    </h4>
                    <p className="text-[#c8c0b0]/50 text-xs" data-id="element-160">
                      Full audio version — listen anywhere, anytime
                    </p>
                  </div>
                </div>
              </div>

              <div className="border-t border-[#c8c0b0]/10 pt-6 text-center" data-id="element-161">
                <div className="text-4xl font-bold text-[#c8c0b0] mb-4" data-id="element-162">
                  $17
                </div>
                <MysticalButton className="w-full" onClick={() => window.open('https://instaflowdp.com/cart/63211325653361:1', '_blank')} data-id="element-163">
                  Get The Essential Pack
                </MysticalButton>
                <p className="text-xs text-[#c8c0b0]/30 mt-3 font-mono tracking-wide" data-id="element-164">
                  Instant Access • Secure Payment
                </p>
              </div>
            </div>
          </div>

          {/* Tier 2 — COMBO (highlighted) */}
          <div className="bg-[#050a0f] border border-[#c9a84c]/50 rounded-xl p-1 relative overflow-hidden shadow-[0_0_30px_rgba(201,168,76,0.15)]" data-id="element-165">
            {/* Gold top bar */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent opacity-70" data-id="element-166" />

            {/* Best Value badge */}
            <div className="absolute top-4 right-4 bg-[#c9a84c] text-[#050a0f] text-xs font-bold font-mono px-3 py-1 rounded tracking-widest flex items-center gap-1" data-id="element-167">
              <Star className="w-3 h-3" data-id="element-168" />
              BEST VALUE
            </div>

            <div className="bg-[#0a1520] rounded-lg p-5 md:p-8 h-full flex flex-col" data-id="element-169">
              <div className="mb-4 md:mb-6" data-id="element-170">
                <div className="text-[#c9a84c] font-mono text-xs tracking-widest mb-2" data-id="element-171">
                  COMPLETE BUNDLE
                </div>
                <h3 className="text-2xl font-bold text-[#c8c0b0]" data-id="element-172">
                  eBook + Audiobook + Guided Meditations
                </h3>
              </div>

              <div className="space-y-3 md:space-y-4 flex-1 mb-5 md:mb-8" data-id="element-173">
                <div className="flex items-start gap-3" data-id="element-174">
                  <div className="w-9 h-9 rounded bg-[#c9a84c]/10 flex items-center justify-center flex-shrink-0 text-[#c9a84c]" data-id="element-175">
                    <BookOpen className="w-4 h-4" data-id="element-176" />
                  </div>
                  <div data-id="element-177">
                    <h4 className="font-bold text-[#c8c0b0] text-sm" data-id="element-178">
                      eBook — PDF Format
                    </h4>
                    <p className="text-[#c8c0b0]/50 text-xs" data-id="element-179">
                      "How to Play the Game" — Read on any device, instantly
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-180">
                  <div className="w-9 h-9 rounded bg-[#c9a84c]/10 flex items-center justify-center flex-shrink-0 text-[#c9a84c]" data-id="element-181">
                    <Headphones className="w-4 h-4" data-id="element-182" />
                  </div>
                  <div data-id="element-183">
                    <h4 className="font-bold text-[#c8c0b0] text-sm" data-id="element-184">
                      Audiobook
                    </h4>
                    <p className="text-[#c8c0b0]/50 text-xs" data-id="element-185">
                      Full audio version — listen anywhere, anytime
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-186">
                  <div className="w-9 h-9 rounded bg-[#00d4ff]/10 flex items-center justify-center flex-shrink-0 text-[#00d4ff]" data-id="element-187">
                    <Brain className="w-4 h-4" data-id="element-188" />
                  </div>
                  <div data-id="element-189">
                    <h4 className="font-bold text-[#c8c0b0] text-sm" data-id="element-190">
                      Guided Meditations
                    </h4>
                    <p className="text-[#c8c0b0]/50 text-xs" data-id="element-191">
                      By Gabriel Beltrán — deep fractal pattern reprogramming
                    </p>
                  </div>
                </div>

                {/* BONUS */}
                <div className="mt-2 rounded-lg border border-[#c9a84c]/30 bg-[#c9a84c]/5 p-3" data-id="element-192">
                  <div className="text-[#c9a84c] font-mono text-[10px] tracking-widest mb-2 flex items-center gap-1" data-id="element-193">
                    <Sparkles className="w-3 h-3" data-id="element-194" />
                    EXCLUSIVE BONUS
                  </div>
                  <div className="flex items-start gap-3" data-id="element-195">
                    <div className="w-9 h-9 rounded bg-[#c9a84c]/10 flex items-center justify-center flex-shrink-0 text-[#c9a84c]" data-id="element-196">
                      <Brain className="w-4 h-4" data-id="element-197" />
                    </div>
                    <div data-id="element-198">
                      <h4 className="font-bold text-[#c9a84c] text-sm" data-id="element-199">
                        DMT Pineal Protocol
                      </h4>
                      <p className="text-[#c8c0b0]/50 text-xs" data-id="element-200">
                        Pineal gland activation guide — unlock your inner access
                        to the simulation
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="border-t border-[#c9a84c]/20 pt-6 text-center" data-id="element-201">
                <div className="text-4xl font-bold text-[#c9a84c] glow-text-gold mb-4" data-id="element-202">
                  $27
                </div>
                <MysticalButton className="w-full" onClick={() => document.getElementById('offer')?.scrollIntoView({
                behavior: 'smooth'
              })} data-id="element-203">
                  Get The Complete Bundle
                </MysticalButton>
                <p className="text-xs text-[#c8c0b0]/30 mt-3" data-id="element-204">
                  Instant Access • Secure Payment
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}